import React, { useImperativeHandle, forwardRef, useState, useEffect } from 'react';
import { Grid, TextField, MenuItem, Box, Typography, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { mockBancos } from '../mock'
import limiteTamanhoCampos from '../limiteCampos'
import { serviceRecuperaOperacoes } from '../Service/service'

const operacoesCaixa = await serviceRecuperaOperacoes();

const FormularioBancario = forwardRef((props, ref) => {
  const [formData, setFormData] = useState(props.formData);
  const refNacional = "nacional";
  const bancos = mockBancos();

  const [validacao, setValidacao] = useState(
    {
      bancoNacional: props.nacionalidade != refNacional,
      bancoCodigoNacional: props.nacionalidade != refNacional,
      bancoAgenciaNacional: props.nacionalidade != refNacional,
      // bancoAgenciaDvNacional: props.nacionalidade != refNacional,
      bancoContaNacional: props.nacionalidade != refNacional,
      bancoContaDvNacional: props.nacionalidade != refNacional,
      bancoTipoContaNacional: props.nacionalidade != refNacional,
      bancoNaturezaContaNacional: props.nacionalidade != refNacional,
      bancoPosicaoContaNacional: props.nacionalidade != refNacional,
      numeroOperacaoNacional: props.nacionalidade != refNacional,

      bancoInternacional: props.nacionalidade == refNacional,
      bancoAgenciaInternacional: props.nacionalidade == refNacional,
      bancoIbanInternacional: props.nacionalidade == refNacional,
      bancoContaInternacional: props.nacionalidade == refNacional,
      bancoSwiftInternacional: props.nacionalidade == refNacional,
      bancoTipoContaInternacional: props.nacionalidade == refNacional,
      bancoNaturezaContaInternacional: props.nacionalidade == refNacional,
      bancoPosicaoContaInternacional: props.nacionalidade == refNacional,
    });

  useEffect(() => {
    validaForm();
  }, [formData]);

  useEffect(() => {
    validaForm();
  }, []);

  const validaForm = () => {
    const propriedades = Object.keys(validacao);
    const novaValidacao = { ...validacao };
    const seCabeValidacao = validarSeAlgumPreenchido();

    propriedades.forEach(propriedade => {
      const seNaoCabeValidacaoNumeroCaixa = propriedade == 'numeroOperacaoNacional' && props.nacionalidade == refNacional && formData?.bancoCodigoNacional != 104;

      if (formData && !seNaoCabeValidacaoNumeroCaixa) {
        const seCabeValidacaoNacional = props.nacionalidade == refNacional && !propriedade.includes('Internacional');
        const seCabeValidacaoInternacional = props.nacionalidade != refNacional && propriedade.includes('Internacional');

        if ((seCabeValidacaoNacional || seCabeValidacaoInternacional) && seCabeValidacao)
          novaValidacao[propriedade] = formData[propriedade] !== "" && formData[propriedade] != undefined && formData[propriedade] != null;
        else
          novaValidacao[propriedade] = true;
      }
      else
        novaValidacao[propriedade] = true;
    });

    setValidacao(novaValidacao);
  }

  const validarSeAlgumPreenchido = () => {
    let propriedades = Object.keys(validacao);

    if (props.nacionalidade == refNacional)
      propriedades = propriedades.filter(t => !t.includes('Internacional'))
    else
      propriedades = propriedades.filter(t => t.includes('Internacional'))

    return propriedades.some(propriedade => formData ? (formData[propriedade] !== "" && formData[propriedade] != undefined && formData[propriedade] != null) : false);
  }

  const handleChange = (event) => {
    let { name, value } = event.target;

    value = limiteTamanhoCampos(name, value);

    setFormData((prevState) => {
      const updatedState = {
        ...prevState,
        [name]: value,
      };

      if (name == 'bancoNacional') {
        const banco = bancos.find(b => b.nome === value);
        updatedState.bancoCodigoNacional = banco.codigo;
      }

      return updatedState;
    });
  };

  useImperativeHandle(ref, () => ({
    validarFormulario() {
      if (Object.values(validacao).some(value => !value)) {
        return false;
      }
      return true;
    },
    getDados() {
      return formData;
    }
  }));

  // const cssQuebraPagina = { 'page-break-after': 'auto', 'break-after': 'page', 'width': '100%' };

  return (
    <>
      {/* <div style={cssQuebraPagina}></div> */}
      <Box sx={{ flexGrow: 1, p: 2 }}>
        <Typography variant="h4" gutterBottom>
          Dados de pagamento
        </Typography>
        {props.nacionalidade == refNacional &&
          <Grid container spacing={2}>
            {/* Linha 1 */}
            <Grid item xs={12} md={6}>
              <TextField
                select
                fullWidth
                label="Banco"
                name='bancoNacional'
                value={formData?.bancoNacional}
                onChange={handleChange}
                variant="outlined"
                margin="normal"
                required
                error={!validacao.bancoNacional && props.nacionalidade == refNacional}
              >
                {bancos.map((banco) => (
                  <MenuItem key={banco.codigo} value={banco.nome}>
                    {banco.nome}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Cód. do Banco"
                name='bancoCodigoNacional'
                value={formData?.bancoCodigoNacional || 0}
                onChange={handleChange}
                variant="outlined"
                margin="normal"
                type="number"
                required
                disabled
                error={!validacao.bancoCodigoNacional && props.nacionalidade == refNacional}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Agência"
                name='bancoAgenciaNacional'
                value={formData?.bancoAgenciaNacional}
                onChange={handleChange}
                variant="outlined"
                margin="normal"
                type="number"
                required
                error={!validacao.bancoAgenciaNacional && props.nacionalidade == refNacional}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="DV (Agência)"
                name='bancoAgenciaDvNacional'
                value={formData?.bancoAgenciaDvNacional}
                onChange={handleChange}
                variant="outlined"
                margin="normal"
                type="number"
                maxLength={1}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Conta"
                name='bancoContaNacional'
                value={formData?.bancoContaNacional}
                onChange={handleChange}
                variant="outlined"
                margin="normal"
                type="number"
                required
                error={!validacao.bancoContaNacional && props.nacionalidade == refNacional}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="DV (Conta)"
                name='bancoContaDvNacional'
                value={formData?.bancoContaDvNacional}
                onChange={handleChange}
                variant="outlined"
                margin="normal"
                maxLength={1}
                required
                error={!validacao.bancoContaDvNacional && props.nacionalidade == refNacional}
              />
            </Grid>
            {formData?.bancoCodigoNacional == 104 &&
              <Grid item xs={6}>
                <TextField
                  select
                  fullWidth
                  label="Número da Operação"
                  name='numeroOperacaoNacional'
                  value={formData?.numeroOperacaoNacional}
                  onChange={handleChange}
                  variant="outlined"
                  margin="normal"
                  required={props.nacionalidade == refNacional && formData?.bancoCodigoNacional == 104}
                  error={!validacao.numeroOperacaoNacional && props.nacionalidade == refNacional && formData?.bancoCodigoNacional == 104}
                >
                  {operacoesCaixa.map((operacao) => (
                    <MenuItem key={operacao} value={operacao}>
                      {operacao}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            }
            <Grid container margin={2}>
              <Grid item sm={4} xs={12}>
                <FormControl component="fieldset" sx={{ height: '100%', width: '80%' }}
                  required
                  error={!validacao.bancoTipoContaNacional && props.nacionalidade == refNacional}
                >
                  <FormLabel component="legend">Tipo de conta</FormLabel>
                  <RadioGroup
                    row
                    name='bancoTipoContaNacional'
                    value={formData?.bancoTipoContaNacional}
                    onChange={handleChange}
                    sx={{ display: "flex", justifyContent: 'space-between' }}
                  >
                    <Grid sx={{ display: "flex", flexDirection: "column" }}>
                      <FormControlLabel value="CC" control={<Radio />} label="Conta Corrente" />
                      <FormControlLabel value="CP" control={<Radio />} label="Conta Poupança" />
                    </Grid>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item sm={4} xs={12}>
                <FormControl component="fieldset" sx={{ height: '100%', width: '80%' }}
                  required
                  error={!validacao.bancoNaturezaContaNacional && props.nacionalidade == refNacional}
                >
                  <FormLabel component="legend">Natureza da Conta</FormLabel>
                  <RadioGroup
                    row
                    name='bancoNaturezaContaNacional'
                    value={formData?.bancoNaturezaContaNacional}
                    onChange={handleChange}
                    sx={{ display: "flex", justifyContent: 'space-between' }}
                  >
                    <Grid sx={{ display: "flex", flexDirection: "column" }}>
                      <FormControlLabel value="N" control={<Radio />} label="Conta Individual" />
                      <FormControlLabel value="S" control={<Radio />} label="Conta Conjunta" />
                    </Grid>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item sm={4} xs={12}>
                <FormControl component="fieldset" sx={{ height: '100%', width: '80%' }}
                  required
                  error={!validacao.bancoPosicaoContaNacional && props.nacionalidade == refNacional}
                >
                  <FormLabel component="legend">Posição do Titular</FormLabel>
                  <RadioGroup
                    row
                    name='bancoPosicaoContaNacional'
                    value={formData?.bancoPosicaoContaNacional}
                    onChange={handleChange}
                    sx={{ display: "flex", justifyContent: 'space-between' }}
                  >
                    <Grid sx={{ display: "flex", flexDirection: "column" }}>
                      <FormControlLabel value="S" control={<Radio />} label="1º Correntista" />
                      <FormControlLabel value="N" control={<Radio />} label="2º Correntista" />
                    </Grid>
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>

          </Grid>
        }
        {
          props.nacionalidade != refNacional &&
          <Grid container spacing={2}>
            {/* Linha 1 */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Banco Internacional"
                name='bancoInternacional'
                value={formData?.bancoInternacional}
                onChange={handleChange}
                variant="outlined"
                margin="normal"
                required
                error={!validacao.bancoInternacional && props.nacionalidade != refNacional}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Agência"
                name='bancoAgenciaInternacional'
                value={formData?.bancoAgenciaInternacional}
                onChange={handleChange}
                variant="outlined"
                margin="normal"
                type="number"
                required
                error={!validacao.bancoAgenciaInternacional && props.nacionalidade != refNacional}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Código IBAN"
                name='bancoIbanInternacional'
                value={formData?.bancoIbanInternacional}
                onChange={handleChange}
                variant="outlined"
                margin="normal"
                type="number"
                required
                error={!validacao.bancoIbanInternacional && props.nacionalidade != refNacional}
              />
            </Grid>

            {/* Linha 3 */}
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Conta"
                name='bancoContaInternacional'
                value={formData?.bancoContaInternacional}
                onChange={handleChange}
                variant="outlined"
                margin="normal"
                type="number"
                required
                error={!validacao.bancoContaInternacional && props.nacionalidade != refNacional}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Codigo SWIFT"
                name='bancoSwiftInternacional'
                value={formData?.bancoSwiftInternacional}
                onChange={handleChange}
                variant="outlined"
                margin="normal"      
                required
                error={!validacao.bancoSwiftInternacional && props.nacionalidade != refNacional}
              />
            </Grid>

            {/* Linha 4 */}
            <Grid item sm={4} xs={12}>
              <FormControl component="fieldset" sx={{ height: '100%', width: '80%' }}
                required
                error={!validacao.bancoTipoContaInternacional && props.nacionalidade != refNacional}>
                <FormLabel component="legend">Tipo de conta</FormLabel>
                <RadioGroup
                  row
                  name='bancoTipoContaInternacional'
                  value={formData?.bancoTipoContaInternacional}
                  onChange={handleChange}
                  sx={{ display: "flex", justifyContent: 'space-between' }}
                >
                  <Grid sx={{ display: "flex", flexDirection: "column" }}>
                    <FormControlLabel value="CC" control={<Radio />} label="Conta Corrente" />
                    <FormControlLabel value="CP" control={<Radio />} label="Conta Poupança" />
                  </Grid>
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item sm={4} xs={12}>
              <FormControl component="fieldset" sx={{ height: '100%', width: '80%' }}
                required
                error={!validacao.bancoNaturezaContaInternacional && props.nacionalidade != refNacional}>
                <FormLabel component="legend">Natureza da Conta</FormLabel>
                <RadioGroup
                  row
                  name='bancoNaturezaContaInternacional'
                  value={formData?.bancoNaturezaContaInternacional}
                  onChange={handleChange}
                  sx={{ display: "flex", justifyContent: 'space-between' }}
                >
                  <Grid sx={{ display: "flex", flexDirection: "column" }}>
                    <FormControlLabel value="N" control={<Radio />} label="Conta Individual" />
                    <FormControlLabel value="S" control={<Radio />} label="Conta Conjunta" />
                  </Grid>
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item sm={4} xs={12}>
              <FormControl component="fieldset" sx={{ height: '100%', width: '80%' }}
                required
                error={!validacao.bancoPosicaoContaInternacional && props.nacionalidade != refNacional}>
                <FormLabel component="legend">Posição do Titular</FormLabel>
                <RadioGroup
                  row
                  name='bancoPosicaoContaInternacional'
                  value={formData?.bancoPosicaoContaInternacional}
                  onChange={handleChange}
                  sx={{ display: "flex", justifyContent: 'space-between' }}
                >
                  <Grid sx={{ display: "flex", flexDirection: "column" }}>
                    <FormControlLabel value="S" control={<Radio />} label="1º Correntista" />
                    <FormControlLabel value="N" control={<Radio />} label="2º Correntista" />
                  </Grid>
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
        }
      </Box>
    </>
  );
});

export default FormularioBancario;
